import { useSession } from './context'

export function SessionGuard({ children }: { children: React.ReactNode }) {
  const { status } = useSession()

  if (status === 'logging-out') {
    return null
  }

  return children
}
